"use strict";
const freeDeliveryLimit = 500;
const deliveryPrice = 20;

export function _refreshCartItems(dataAll) {

    jQuery('#sbasket-list').empty();
    jQuery.each(dataAll, function (key, data) {
        jQuery('#sbasket-list').append(_insertNewCartItem(data));
    })


}

export function _insertCartItem(data) {

    let discountDisplay = '';
    let price = data.price;

    if (data.discount > 0) {
        price = data.priceDiscount;
        discountDisplay = '<div class="sl-cart-discount"><span>-' + data.discount + '% ' + data.discountLabel + '</span> <del>' + data.price + '</del></div>';
    }

    return '<li class="header-cart-item flex-w flex-t m-b-12" data-id="' + data.id + '" data-product-id="' + data.idproduct + '">' +
        '<div class="header-cart-item-img"><img src="' + data.img + '" alt="'+ data.name +'" width="60px" height="60px"><i class="skl-icon-close"></i></div>' +
        '<div class="header-cart-item-txt p-t-8">' +
        '<a href="#" class="header-cart-item-name m-b-18 hov-cl1 trans-04">' + data.name + '</a>' +
        discountDisplay +
        '<span id="sbqty_' + data.idproduct + '" class="header-cart-item-info sl-price" data-qty="1"> 1 x ' + price + ' RON </span>' +
        '</div> </li>';

}

export function _insertNewCartItem(data) {

    let discountDisplay = '';
    let price = data.price;

    if (data.discount > 0) {
        price = data.priceDiscount;
        discountDisplay = '<div class="sl-cart-discount"><span>-' + data.discount + '% ' + data.discountLabel + ' </span> <del>' + data.price + '</del></div>';
    }

    return '<li class="header-cart-item flex-w flex-t m-b-12" data-id="' + data.id + '" data-product-id="' + data.idproduct + '">' +
        '<div class="header-cart-item-img"><img src="' + data.img + '" alt="'+ data.name +'" width="60px" height="60px"><i class="skl-icon-close"></i></div>' +
        '<div class="header-cart-item-txt p-t-8">' +
        '<a href="/linkto/product/' + data.idproduct + '" class="header-cart-item-name m-b-18 hov-cl1 trans-04">' + data.name + '</a>' +
        discountDisplay +
        '<span id="sbqty_' + data.idproduct + '" class="header-cart-item-info sl-price" data-qty="'+ data.qty +'"> ' + data.qty + ' x ' + price + ' RON </span>' +
        '</div> </li>';

}

export function minusQty() {


        const idproduct = jQuery(this).data('idproduct');
        const id = jQuery(this).data('id');
        const price = jQuery(this).data('price');
        const qty = parseInt(jQuery('#qty_' + id).html());

        jQuery('.minus-qty').attr('disabled');
        jQuery('.plus-qty').attr('disabled');

        jQuery('#price_' + id).html('<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>');
        //ajax update qty
        const data = {id: id, changeType: 2}
        if (qty === 1) {
            jQuery('#qty_' + id).html('1');
            jQuery('#sbqty_' + idproduct).data(qty, 1).html('1 x ' + price);
            jQuery('#price_' + id).html('<b>' + price + '</b>');
            jQuery('.minus-qty').removeAttr('disabled');
            jQuery('.plus-qty').removeAttr('disabled');

        } else {
            _updateCart('/ajax/updateqtycart', data, function (resdata) {
                const newQty = qty - 1;
                jQuery('#qty_' + id).html(newQty);
                jQuery('#price_' + id).html('<b>' + (newQty * price).toFixed(2) + '</b>');
                jQuery('#sbqty_' + idproduct).data(qty, newQty).html(newQty + ' x ' + price);
                jQuery('.minus-qty').removeAttr('disabled');
                jQuery('.plus-qty').removeAttr('disabled');
                jQuery('#totalQtyLabel').attr('data-notify', resdata.cartQty);
                jQuery('.sbtotalBasketLabel').html(resdata.cartTotal + resdata.deliveryPrice);
                jQuery('.header-cart-delivery .delivery-price').html((resdata.cartTotal >= freeDeliveryLimit ? 0 : deliveryPrice));
                jQuery('.header-cart-delivery-cost').removeClass('active');
                if (freeDeliveryLimit - resdata.cartTotal > 0) {
                    jQuery('.header-cart-delivery-cost--paid').addClass('active');
                    jQuery('.header-cart-delivery-cost--paid .delivery-price').html(freeDeliveryLimit - resdata.cartTotal);
                } else {
                    jQuery('.header-cart-delivery-cost--free').addClass('active');
                }
                jQuery('#totalBasketLabel').html(resdata.cartTotal + resdata.deliveryPrice);
                jQuery('#totalBasketFooterLabel').html(resdata.cartTotal + resdata.deliveryPrice);

                document.dispatchEvent(new CustomEvent("sklCartUpdated", {
                    detail: resdata
                }));
            });

        }
}

export function plusQty() {

        // jQuery('.toast').toast({animation:true,autohide:true,delay:1000});
        // jQuery('.toast').toast('show');
        // console.log('plus qty')
        jQuery(this).prop('disabled', true);
        jQuery(this).attr('disabled');
        const idproduct = jQuery(this).data('idproduct');
        const id = jQuery(this).data('id');
        const price = jQuery(this).data('price');
        //jQuery('#price_' + id).html('<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>');
        const qty = parseInt(jQuery('#qty_' + id).html()) + 1;
        const data = {id: id, changeType: 1}

        _updateCart('/ajax/updateqtycart', data, function (resdata) {
            jQuery('#price_' + id).html('<b>' + (qty * price).toFixed(2) + '</b>');
            jQuery('#qty_' + id).html(qty);
            jQuery('.minus-qty').removeAttr('disabled');
            jQuery('.plus-qty').removeAttr('disabled');
            jQuery('#sbqty_' + idproduct).html(qty + ' x ' + price);
            jQuery('#totalQtyLabel').attr('data-notify', resdata.cartQty);
            jQuery('.sbtotalBasketLabel').html(resdata.cartTotal + resdata.deliveryPrice);
            jQuery('.header-cart-delivery .delivery-price').html((resdata.cartTotal >= freeDeliveryLimit ? 0 : deliveryPrice));
            jQuery('.header-cart-delivery-cost').removeClass('active');
            if (freeDeliveryLimit - resdata.cartTotal > 0) {
                jQuery('.header-cart-delivery-cost--paid').addClass('active');
                jQuery('.header-cart-delivery-cost--paid .delivery-price').html(freeDeliveryLimit - resdata.cartTotal);
            } else {
                jQuery('.header-cart-delivery-cost--free').addClass('active');
            }
            jQuery('#totalBasketLabel').html(resdata.cartTotal + resdata.deliveryPrice);
            jQuery('#totalBasketFooterLabel').html(resdata.cartTotal + resdata.deliveryPrice);

            document.dispatchEvent(new CustomEvent("sklCartUpdated", {
                detail: resdata
            }));
        });
}

export function deleteFromCart() {

        const id = jQuery(this).data('id');
        const data = {id: id};
        const thisitem = this;

        _updateCart('/ajax/deletecartitem', data, function (resdata) {

            jQuery(thisitem).parents('.row-item')
                .css("background-color", "#FF3700")
                .fadeOut(400, function () {
                    jQuery(this).remove();
                });
            //console.log(resdata);
            jQuery('#totalQtyLabel').attr('data-notify', resdata.cartQty);
            jQuery('.sbtotalBasketLabel').html(resdata.cartTotal);
            jQuery('.header-cart-delivery .delivery-price').html((resdata.cartTotal >= freeDeliveryLimit ? 0 : deliveryPrice));
            jQuery('.header-cart-delivery-cost').removeClass('active');
            if (freeDeliveryLimit - resdata.cartTotal > 0) {
                jQuery('.header-cart-delivery-cost--paid').addClass('active');
                jQuery('.header-cart-delivery-cost--paid .delivery-price').html(freeDeliveryLimit - resdata.cartTotal);
            } else {
                jQuery('.header-cart-delivery-cost--free').addClass('active');
            }
            jQuery('#totalBasketFooterLabel').html(resdata.cartTotal + resdata.deliveryPrice);
            jQuery('#ddc-' + id).remove();
            jQuery('#sbddc_' + id).remove();

            document.dispatchEvent(new CustomEvent("sklCartUpdated", {
                detail: resdata
            }));
        });

}

export function deleteFromCartDiv() {

        const id = jQuery(this).data('id');
        const data = {id: id};
        // const thisitem = this;
        //console.log('delete from cart');

        _updateCart('/ajax/deletecartitem', data, function (resdata) {

            jQuery('#r' + id).css("background-color", "#FF3700")
                .fadeOut(400, function () {
                    jQuery('#r' + id).remove();
                });

            jQuery('#totalQtyLabel').attr('data-notify', resdata.cartQty);
            jQuery('.mbtotalQtyLabel').html(resdata.cartQty);

            jQuery('.sbtotalBasketLabel').html(resdata.cartTotal + resdata.deliveryPrice);
            jQuery('.header-cart-delivery .delivery-price').html((resdata.cartTotal >= freeDeliveryLimit ? 0 : deliveryPrice));
            jQuery('.header-cart-delivery-cost').removeClass('active');
            if (freeDeliveryLimit - resdata.cartTotal > 0) {
                jQuery('.header-cart-delivery-cost--paid').addClass('active');
                jQuery('.header-cart-delivery-cost--paid .delivery-price').html(freeDeliveryLimit - resdata.cartTotal);
            } else {
                jQuery('.header-cart-delivery-cost--free').addClass('active');
            }
            jQuery('#totalBasketFooterLabel').html(resdata.cartTotal + resdata.deliveryPrice);
            jQuery('#ddc-' + id).remove();
            jQuery('#sbddc_' + id).remove();

            document.dispatchEvent(new CustomEvent("sklCartUpdated", {
                detail: resdata
            }));
        });
}


export function _updateCart(url, data, action) {
    //console.log(data);
    jQuery.ajax({
        type: "POST",
        url: url,
        data: data,
        success: function (response) {
            try {
                const res = jQuery.parseJSON(response);
                if (res.success == true) {
                    //toast.success('Successfully , executat cu success');
                    action(res);
                    //console.log('success response');

                } else {
                    //toast.alert('Eroare la procesare');
                    //console.log('error response');
                    if (res.message) {
                        swal('Cantitate insuficienta', res.message, "error");
                    } else {
                        swal('Cantitate', "Eroare la modificare cantitate !", "error");
                    }
                }
            } catch (e) {
                //toast.alert('Eroare la procesare date ');
                return;
            }


        },
    });


}

// Remove this legacy code after checkout page refactoring
export default function init() {
    // Cart checkout page:
    jQuery('.minus-qty').on('click', minusQty);
    jQuery('.plus-qty').on('click', plusQty);
    jQuery('.delete-from-cart').on('click', deleteFromCart);
    jQuery('.delete-from-cart-div').on('click', deleteFromCartDiv);
}
